import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["keyContent", "copyButton"]

  connect() {

    // Format the key content on connect
    if (this.hasKeyContentTarget) {
      this.formatKey()
    }

  }

  formatKey() {
    // Get the raw key content
    const rawKey = this.keyContentTarget.dataset.publicKey || this.keyContentTarget.textContent.trim()
    
    // The key should already have newlines, but ensure it's displayed properly
    this.keyContentTarget.textContent = rawKey
  }

  copyToClipboard(event) {
    const keyText = this.keyContentTarget.textContent
    
    navigator.clipboard.writeText(keyText).then(() => {
      // Update button to show success
      const originalContent = this.copyButtonTarget.innerHTML
      this.copyButtonTarget.innerHTML = '<i class="fa-regular fa-check"></i> ' + (this.copyButtonTarget.dataset.copiedText || 'Copied!')
      this.copyButtonTarget.classList.add('btn-success')
      this.copyButtonTarget.classList.remove('btn-primary')
      
      // Reset button after 2 seconds
      setTimeout(() => {
        this.copyButtonTarget.innerHTML = originalContent
        this.copyButtonTarget.classList.remove('btn-success')
        this.copyButtonTarget.classList.add('btn-primary')
      }, 2000)
    })
    .catch(err => {
      console.error('Failed to copy text: ', err)
      // Show error state
      const originalContent = this.copyButtonTarget.innerHTML
      this.copyButtonTarget.innerHTML = '<i class="fa-regular fa-times"></i> Error'
      this.copyButtonTarget.classList.add('btn-danger')
      this.copyButtonTarget.classList.remove('btn-primary')
      
      setTimeout(() => {
        this.copyButtonTarget.innerHTML = originalContent
        this.copyButtonTarget.classList.remove('btn-danger')
        this.copyButtonTarget.classList.add('btn-primary')
      }, 2000)
    })
  }
}